export const config = {
  /** API サーバーの URL（テスト・CI 用） */
  apiUrl: "http://localhost:3000",
  /** GTM コンテナ ID（テスト環境では無効） */
  gtmContainerId: null,
  planCodes: {
    free: "free",
    beginner: "beginner",
    enterprise: "enterprise",
  },
  bypassPlanGate: false,
} as const;
